import React, { useState, useRef, useEffect, useCallback } from 'react';
// import { useTranslation } from "react-i18next";
import { Row, Col } from 'react-bootstrap';
import { motion } from "framer-motion";
import Table from 'react-bootstrap/Table';
import "../../../../../styles/_common.scss";
// import "./index.scss";

import NoDataFound from "../../../../../components/ui/NoDataFound";
import SkeletonLoader from "../../../../../components/ui/SkeletonLoader";
import Pagination from "../../../../../components/ui/Pagination";
import ListFilter from "../../../../../components/PostLogin/ScanInfo/ExposureManagement/ConcerningExposure/ListFilter";

import { formatDate, formatNumber } from "../../../../../utils/util";
import { searchIcon } from "../../../../../utils/icons";

import { useScanInfoContext } from "../../../../ScanInfo/ScanInfoContext";

import apiEndpoints from "../../../../../apiEndpoints";

import { useSelector, useDispatch } from 'react-redux';
import { getThirdPartyRiskStats, resetThirdPartyRiskStats, getSimilarDoaminList, resetSimilarDomainList } from "../../../../../store/actions/thirdPartyRiskAction";

const DoaminSimilarities = () => {

    const similarDomainStatsResponse = useSelector((state) => state.thirdPartyRisk?.thirdPartyRiskStats);
    const similarDomainListResponse = useSelector((state) => state.thirdPartyRisk?.similarDomainList)

    const prevDomainIdRef = useRef(null);
    const prevScanIdRef = useRef(null);

    const dispatch = useDispatch();

    const { domainId, scanId, organizationId } = useScanInfoContext();

    const [searchValue, setSearchValue] = useState("");
    const [searchQuery, setSearchQuery] = useState("");
    const [isSearchFocused, setIsSearchFocused] = useState(false);

    const [currentPage, setCurrentPage] = useState(1);
    const [currentPageSize, setCurrentPageSize] = useState(10);
    const [isLoading, setIsLoading] = useState(false);
    const [similarDomainList, setSimilarDomainList] = useState(null);
    const [scanNotFound, setScanNotFound] = useState(false);
    const [similarDomainStats, setSimilarDomainStats] = useState("");
    const [statsLoading, setStatsLoading] = useState(false);

    const [listFilterValue, setListFilterValue] = useState({});

    const setCurrentPageandRecordSize = (currentPage, pageSize) => {
        setCurrentPage(currentPage);
        if(pageSize !== currentPageSize) {
            setCurrentPageSize(pageSize);
            setCurrentPage(1);
        }
    }

    const listFilterApply = (data) => {
        setCurrentPage(1);
        setListFilterValue(data)
    }

    const isAnyFilterActive = Object.values(listFilterValue).some(value => Boolean(value));

    const resetFilterValue = () => {
        setCurrentPage(1);
        setListFilterValue({});
    }

    const handleSearchKeyDown = (event) => {
        if (event.key === "Enter" && isSearchFocused) {
            onSearch()
        }
    }

    const onSearch = () => {
        setCurrentPage(1)
        setSearchQuery(searchValue)
    }

    const fetchSimilarDomainStats = useCallback(()=>{
        setStatsLoading(true)
        const baseUrl = `${apiEndpoints.scanInfo.thirdPartyRisk.brandInsight.similarDomain.similarDomainStats()}`
        const params = organizationId.toLowerCase() !== "all" && domainId.toLowerCase() === "all" ? `&organization_id=${organizationId}`: `&domain=${domainId}&scan_id=${scanId}`
        const url = `${baseUrl}${params}`
        dispatch(getThirdPartyRiskStats(url))
    },[dispatch, domainId, scanId, organizationId])

    const fetchSimilarDoaminList = useCallback(() => {
        setIsLoading(true)
        const baseUrl = `&page=${currentPage}&page_size=${currentPageSize}`;
        const params = organizationId.toLowerCase() !== "all" && domainId.toLowerCase() === "all" ? `&organization_id=${organizationId}`: `&domain=${domainId}&scan_id=${scanId}`
        const queryParams = searchQuery ? `&query=${searchQuery}` : "";
        const newFindings = listFilterValue.newFindings && listFilterValue.newFindings !== "all" ? `&new_record=${listFilterValue.newFindings.value === "yes" ? true : false}` : "";
        const url = `${baseUrl}${params}${queryParams}${newFindings}`
        dispatch(getSimilarDoaminList(url))
    },[currentPage, currentPageSize, domainId, organizationId, scanId, dispatch, searchQuery, listFilterValue])

    useEffect(()=>{        
        fetchSimilarDoaminList();
    },[currentPage, fetchSimilarDoaminList])

    useEffect(()=>{
        if(domainId !== prevDomainIdRef.current || scanId !== prevScanIdRef.current) {
            fetchSimilarDomainStats()
            setCurrentPage(1)
            prevDomainIdRef.current = domainId;
            prevScanIdRef.current = scanId;
        }
    },[domainId, scanId, fetchSimilarDomainStats, fetchSimilarDoaminList])

    useEffect(()=>{    
        if(similarDomainStatsResponse !== null) {
            setStatsLoading(false)
            setSimilarDomainStats(similarDomainStatsResponse)
            dispatch(resetThirdPartyRiskStats())
        }
    },[similarDomainStatsResponse, dispatch])

    useEffect(()=>{
        if(similarDomainListResponse != null) {            
            setSimilarDomainList(similarDomainListResponse)
            if(similarDomainListResponse?.status === "failed") {
                setScanNotFound(true)
            } else {
                setScanNotFound(false)
            }
            dispatch(resetSimilarDomainList())
            setIsLoading(false)
        }
    },[similarDomainListResponse, dispatch])


    return (
        <>
            <div className="scan-info-main-content">
                <div className="bg-white-with-shadow p-4">
                    <Row>                        
                        <Col lg={4}>
                            <div className="discover-doamin-container associated-doamin-page rounded p-3">
                                {
                                    statsLoading ?
                                    <SkeletonLoader type={"line"} count={2} currentPage={"similarDomain"} />
                                    :
                                    <motion.div
                                        initial={{ opacity: 0, y: 20 }}
                                        animate={{ opacity: 1, y: 0 }}
                                        transition={{ duration: 0.4 }}
                                    >
                                        
                                        <div className="header-content d-flex justify-content-between">
                                            <p className="heading">Similar Domains</p>
                                        </div>
                                        <div className="d-flex gap-3">
                                            <div className="total-score-container rounded">
                                                <div className="users-totol-count d-flex">
                                                    <p className="total-score-count">{formatNumber(similarDomainStats?.stats?.record_type?.total)}</p>
                                                    <div className="score-count mx-3">
                                                        <span className="new-record d-inline-block mx-1"></span>
                                                        <span className="existing-record d-inline-block"></span>
                                                        <p>Total Similar Domain</p>
                                                    </div>
                                                </div>
                                                <div className="new-exist-count d-flex gap-5 mt-3">
                                                    <p className="new-record"><span className="d-inline-block">{formatNumber(similarDomainStats?.stats?.record_type?.new_record)}</span> New</p>
                                                    <p className="existing-record"><span className="d-inline-block">{formatNumber(similarDomainStats?.stats?.record_type?.existing_record)}</span> Existing</p>
                                                </div>
                                            </div>
                                        </div>
                                    </motion.div>
                                }
                            </div>                            
                        </Col>
                    </Row>
                </div>
                <div className="domain-similarities-container git-leaks-main-content bg-white-with-shadow p-3 mt-3">
                    <div className="search-header-container d-flex align-items-center gap-3">
                        <div className="d-flex gap-3">
                            <div className="search-container position-relative" onKeyDown={handleSearchKeyDown}>
                                <span className="position-absolute">{searchIcon()}</span>
                                <input type="text" 
                                    placeholder="Search"
                                    value={searchValue} 
                                    onChange={(e)=>{
                                        setSearchValue(e.target.value)
                                    }}
                                    onFocus={() => setIsSearchFocused(true)}
                                    onBlur={() => setIsSearchFocused(false)}
                                />
                            </div>
                            <button className="search-btn" onClick={onSearch}>Search</button>
                        </div>
                        <ListFilter currentPage="doaminSimilarities" listFilterApply={listFilterApply} listFilterValue={listFilterValue}/>
                        {isAnyFilterActive && (<span className="reset-filter-link" onClick={resetFilterValue}>Reset Filter</span>)}
                    </div>
                    <div className="table-container js-secrets-table third-party-similar-domain-table mt-4">
                        {
                            isLoading ?
                            <SkeletonLoader type={"line"} count={5} currentPage={"similarDomain"} />
                            :
                            <Table>
                                <thead>
                                    <tr>
                                        <th>Similar Domain</th>
                                        <th>Registrar</th>
                                        <th>Email Address</th>
                                        <th>Created</th>
                                        <th>Expiry</th>
                                        <th>Similarity</th>
                                        <th>Blacklisting Status</th>
                                        <th>Web Risk</th>
                                    </tr>                                
                                </thead>
                                <tbody>
                                    {
                                        similarDomainList?.results?.length > 0 &&
                                        similarDomainList?.results?.map((data, index)=>{
                                            return (
                                                <motion.tr
                                                    key={index}
                                                    initial={{ opacity: 0, y: 20 }}
                                                    animate={{ opacity: 1, y: 0 }}
                                                    transition={{ duration: 0.4, delay: index * 0.1 }}
                                                >
                                                    <td className="doamin-name">
                                                        <p className="dns-record-subdomain">{data?.similar_domain}</p>
                                                        <span className="d-block dns-record-domain">{data?.domain}</span>
                                                        {data?.new_record && <span className="d-inline-block new-data my-2">New</span>}
                                                    </td>
                                                    <td className="doamin-registrar">{data?.registrar_name}</td>
                                                    <td className="email-address">{data?.email_address !== null ? data?.email_address : "-"}</td>                                                    
                                                    <td className="created-date">{formatDate(data?.created_at,"date")}</td>
                                                    <td className="expiry-date">{formatDate(data?.expiry_date,"date")}</td>
                                                    <td className="percentage">{data?.additional_info?.similarity_score?.overall}%</td>
                                                    <td className="status-container">
                                                        {data?.additional_info?.blacklisted?.is_blacklisted && <p className="status-open">Blacklisted</p>}
                                                        {!data?.additional_info?.blacklisted?.is_blacklisted && <p className="status-close">Not Blacklisted</p>}
                                                    </td>
                                                    <td className="web-risk">{data?.additional_info?.web_risk.length > 0 ?
                                                        data?.additional_info?.web_risk.map((data, index)=>{
                                                            return (
                                                                <span className="d-inline-block new-data my-2 mx-2" key={`web-risk-${index}`}>{data}</span>
                                                            )
                                                        })                                                        
                                                        : "-"}
                                                    </td>
                                                </motion.tr>
                                            )
                                        })
                                    }
                                </tbody>
                            </Table> 
                        }
                        { !isLoading && similarDomainList && !scanNotFound && similarDomainList?.results?.length > 0 &&
                            <Pagination
                                className="pagination-bar"
                                currentPage={currentPage}
                                pageSize={currentPageSize}
                                totalCount={similarDomainList?.meta?.total_results}
                                onPageChange={setCurrentPageandRecordSize}
                            />
                        }
                        {
                            !isLoading && !scanNotFound && similarDomainList !== "" && similarDomainList?.results?.length === 0 && 
                            <motion.div
                                initial={{ opacity: 0, y: 20 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.4 }}
                            >
                                <NoDataFound noDataText={"No Record Found"}/>
                            </motion.div>
                        }
                        {
                            !isLoading && scanNotFound && 
                            <motion.div
                                initial={{ opacity: 0, y: 20 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.4 }}
                            >
                                <NoDataFound noDataText={similarDomainList?.description}/>
                            </motion.div>
                        }
                    </div>
                </div>                
            </div>
        </>        
    )
}


export default DoaminSimilarities;